"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * @param prop - The prop you want mapped
 * @param values - The possible values
 * @param defaultValue - Fallback value
 * @returns {Function}
 */
var _default = function _default(prop, values, defaultValue) {
  return function (props) {
    if (props.hasOwnProperty(prop)) {
      var val = props[prop];

      if (values.hasOwnProperty(val)) {
        return values[val];
      }
    }

    return defaultValue;
  };
};

exports["default"] = _default;